import * as React from 'react'
import { useState } from 'react'
import { AlertModel } from '@/app/models/alert/alertModel'
import { DriverModel, VehicleModel } from '@/app/models'
import { LoaderIcon } from '@/app/features/icons/Loader'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import CreateNewAlertHeader from './CreateNewAlertHeader'
import CreateNewAlertFooter from './CreateNewAlertFooter'
import AddAlertForm from '../forms/alert/AddAlertForm'

const ADD_ALERT_FORM_ID = 'add-alert-form'

type CreateNewAlertModalProps = {
  handleClose: () => void
  onSave?: () => void
  editedAlert?: AlertModel | null
  companyId: string
  drivers: DriverModel[]
  vehicles: VehicleModel[]
}

const CreateNewAlertModal: React.FC<CreateNewAlertModalProps> = ({
  handleClose,
  onSave,
  editedAlert,
  companyId,
  drivers,
  vehicles,
}) => {
  const [loading, setLoading] = useState(false)

  return (
    <ModalLayout>
      <div
        className="tw-relative tw-flex tw-h-fit tw-max-h-[90vh] tw-w-full tw-max-w-[560px] tw-flex-col tw-rounded-lg tw-bg-white tw-shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {loading && (
          <div className="tw-absolute tw-inset-0 tw-z-[200] tw-grid tw-place-items-center tw-rounded-lg tw-bg-black/30 tw-backdrop-blur-sm">
            <LoaderIcon className="tw-animate-spin" />
          </div>
        )}

        <CreateNewAlertHeader handleClose={handleClose} isEdit={!!editedAlert} />

        <AddAlertForm
          formId={ADD_ALERT_FORM_ID}
          handleClose={handleClose}
          onSave={onSave}
          editedAlert={editedAlert}
          companyId={companyId}
          drivers={drivers}
          vehicles={vehicles}
          onLoadingChange={setLoading}
        />

        <CreateNewAlertFooter loading={loading} formId={ADD_ALERT_FORM_ID} />
      </div>
    </ModalLayout>
  )
}

export default CreateNewAlertModal
